import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import * as Widget from "../Widget2";
import ActionCreator from "../../ActionCreator";
import * as Icon from "../Icon";

import GA from "../../Utils/GA";

const PageNumber = styled.div`
  cursor: pointer;
  margin: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
  min-height: 34px;
  color: ${props => (props.selected ? "#ffffff" : "#755b41")};
  border-radius: 18px;
  border: 1px solid #755b41;
  background-color: ${props => (props.selected ? "#755b41" : "#ffffff")};
  font-size: 14px;
`;

class Paging extends React.Component {
  render() {
    let { page } = this.props;

    return (
      <Widget.Row style={{ justifyContent: "center", alignItems: "center" }}>
        {page.current == 1 ? (
          <div style={{ width: 24 }} />
        ) : (
          <Icon.KeyboardArrowLeft
            onClick={() => {
              page.go(page.current - 1);
              this._trackingPageClick("prev", page.current - 1);
            }}
            color={"#755b41"}
            style={{ cursor: "pointer" }}
            size={26}
          />
        )}

        {page.pages && page.pages.length <= 5
          ? page.pages.map(p => (
              <PageNumber
                key={p}
                onClick={() => {
                  page.go(p);
                  this._trackingPageClick("page", p);
                }}
                selected={page.current === p}
              >
                {p}
              </PageNumber>
            ))
          : this._getPageRange(page).map(p => (
              <PageNumber
                key={p}
                onClick={() => {
                  page.go(p);
                  this._trackingPageClick("page", p);
                }}
                selected={page.current === p}
              >
                {p}
              </PageNumber>
            ))}
        {page.current == page.pages.length ? (
          <div style={{ width: 24 }} />
        ) : (
          <Icon.KeyboardArrowRight
            onClick={() => {
              page.go(page.current + 1);
              this._trackingPageClick("next", page.current + 1);
            }}
            color={"#755b41"}
            style={{ cursor: "pointer" }}
            size={26}
          />
        )}
      </Widget.Row>
    );
  }

  _trackingPageClick = (action, page) => {
    GA.customEvent("Click", "Page", action, page);
  };

  _getPageRange = page => {
    let current = page.current;
    let range = page.pages;

    if (current % 5 === 0) {
      range = [current - 4, current - 3, current - 2, current - 1, current];
    } else if (current % 5 === 1) {
      range = [current, current + 1, current + 2, current + 3, current + 4];
    } else if (current % 5 === 2) {
      range = [current - 1, current, current + 1, current + 2, current + 3];
    } else if (current % 5 === 3) {
      range = [current - 2, current - 1, current, current + 1, current + 2];
    } else if (current % 5 === 4) {
      range = [current - 3, current - 2, current - 1, current, current + 1];
    }

    if (range.indexOf(page.pages.length) > -1) {
      range = range.slice(0, range.indexOf(page.pages.length) + 1);
    }

    return range;
  };
}

export default connect(
  (state, ownProps) => ({
    //
  }),
  ActionCreator
)(Paging);
